<template>
  <div
    v-if="showComponent"
    class="px-3 py-3">
    <div class="d-flex flex-column align-items-center">
      <validation-observer
        tag="form"
        class="d-flex">
        <div class="form-group calendar-inline">
          <label
            for="duplicate-date"
            class="text-center w-100">
            Kopiuj trasy z dnia:
          </label>
          <validation-provider
            rules="required"
            name="duplicate-date"
            v-slot="{ errors }">
            <date-picker
              v-model="data.selectedDate"
              :inline="true"
              valueType="format"
              class="mr-2 w-100"/>
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
      </validation-observer>
      <div>
        <d-button
          theme="success"
          class="text-nowrap ml-2"
          @click.prevent="copyRoutes"
          :disabled="!data.selectedDate">
          Kopiuj trasy
        </d-button>
      </div>
    </div>
  </div>
</template>

<script>
import FormUtils from '@/utils/FormUtils.js';
import DatePicker from 'vue2-datepicker';

export default {
  name: 'orders-transport-duplicate',
  components: {
    DatePicker
  },
  data () {
    return {
      data: {
        selectedDate: null
      },
    };
  },
  props: {
    showComponent: {
      type: Boolean,
      default: false
    },
    currentDate: {
      type: Object,
      required: true
    }
  },
  watch: {
    showComponent () {
      this.data.selectedDate = this.getDateToCopy();
    }
  },
  mounted () {
    this.data.selectedDate = this.getDateToCopy();
  },
  methods: {
    copyRoutes () {
      let formDataToSend = {
        duplicate_from_date: this.data.selectedDate,
        delivery_date: this.prepareDateString(this.getDate(this.currentDate)),
      };

      FormUtils.submit(this, {
        endpoint: '/orders/duplicate-route-plan',
        formData: formDataToSend,
        successTitle: 'Skopiowano trasy',
        successText: 'Trasy z wybranego dnia zostały skopiowane',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Kopiowanie tras nie powiodło się. Spróbuj ponownie.',
        successAction: () => {
          this.$bus.$emit('show-main-view');
        }
      });
    },
    getDateToCopy () {
      let newDate = this.getDate(this.currentDate);
      newDate.setDate(newDate.getDate() - 7);

      return this.prepareDateString(newDate);
    },
    getDate (dateObject) {
      let newDate = new Date();
      newDate.setDate(dateObject.date);
      newDate.setMonth(dateObject.month - 1);
      newDate.setYear(dateObject.year);

      return newDate;
    },
    prepareDateString (input) {
      if (input === null) {
        return null;
      }
      input = new Date(input);

      return [
        input.getFullYear(),
        input.getMonth() + 1,
        input.getDate()
      ]
        .map(n => (n < 10 ? '0' + n : n))
        .join('-');
    },
  }
};
</script>
